import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnIconModule } from '@lib/ui/icon';

/**
 * Toggle for showing or hiding results with warnings
 * OFF: Show only successful results
 * ON: Show all results including those with filter incompatibilities
 */
@Component({
  selector: 'fs-lpr-source-partial-matches',
  standalone: true,
  templateUrl: './lpr-source-partial-matches.component.html',
  styleUrls: ['./lpr-source-partial-matches.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatSlideToggleModule,
    MatTooltipModule,
    SnIconModule,
    TranslationModule,
  ],
})
export class LPRSourcePartialMatchesComponent {
  arePartialMatchesShown = false;
  @Output() partialMatchesDisplayChange = new EventEmitter<boolean>();

  onToggleChange(value: boolean): void {
    this.arePartialMatchesShown = value;
    this.partialMatchesDisplayChange.emit(value);
  }
}
